import {
  CustomerProfileDto,
  CustomerProfileListResponse,
  CustomerProfileLookupDto,
  CustomerProfileWithCardProfileDto,
  PublicCustomerController,
  PublicCustomerProfileController,
  PublicCustomerProfileControllerGetAllData,
  PublicCustomerProfileControllerGetAllLookupData,
} from '@/api';
import { getQueryParams } from '@/utils/api';

export type CustomerProfileQuery = PublicCustomerProfileControllerGetAllData['query'];
export type CustomerProfileQueryLookup = PublicCustomerProfileControllerGetAllLookupData['query'];

export default {
  getCustomerProfileListByCustomerId: async (customerId: string): Promise<CustomerProfileWithCardProfileDto[]> => {
    const response = await PublicCustomerController.getCustomerProfilesByCustomerId({
      path: { id: customerId },
    });

    return response.data!.data;
  },

  getCustomerProfileList: async (queryParams?: CustomerProfileQuery): Promise<CustomerProfileDto[]> => {
    const defaultQuery = { sortBy: 'profileNumber', sortDesc: false, limit: 999 };
    const response = await PublicCustomerProfileController.getAll({
      query: {
        ...defaultQuery,
        ...getQueryParams(queryParams || {}),
      },
    });

    return (response.data as CustomerProfileListResponse).data;
  },

  getCustomerProfileListLookup: async (): Promise<CustomerProfileLookupDto[] | undefined> => {
    const defaultQuery: CustomerProfileQueryLookup = { sortBy: 'profileNumber', sortDesc: false, limit: 999 };
    const { data } = await PublicCustomerProfileController.getAllLookup({
      query: defaultQuery,
    });

    return data?.data;
  },

  getRegularCustomerProfile: async (): Promise<CustomerProfileDto> => {
    const response = await PublicCustomerProfileController.getRegular();

    return response.data!.data;
  },
};
